angular.module('impactx.basket').component('ixBasketControlsInput', {
    bindings: {
        aat: "<",
        controls: "<",
        hideHeader: "<",
        headline: "@",
        openDialog: '&?',
        remove: '&?'
    },
    templateUrl: 'modules/basket/templates/basket-controls-input.tmpl.html',
    controller: 'BasketControlsInputCtrl'
});